import { useEffect, useState } from "react";
import { Sparkles, Inbox, Users, Youtube, Bell, BookOpen } from "lucide-react";
import { api } from "@/lib/api";

const cards = [
  { key: "services", label: "Services actifs", icon: Sparkles, sub: (s) => `${s.services_visible}/${s.services} visibles` },
  { key: "books", label: "Livres", icon: BookOpen, sub: () => "Bibliothèque" },
  { key: "reservations", label: "Demandes reçues", icon: Inbox, sub: (s) => `${s.reservations_new} nouvelles` },
  { key: "members", label: "Membres du Cercle", icon: Users, sub: () => "Communauté" },
  { key: "youtube", label: "Vidéos YouTube", icon: Youtube, sub: () => "Publiées" },
];

export const Overview = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  if (!stats) return <div className="text-slate-500">Chargement…</div>;

  return (
    <div data-testid="admin-overview">
      <h1 className="font-serif text-3xl text-amber-50 mb-2">Aperçu</h1>
      <p className="text-slate-400 mb-8">Vue d'ensemble de votre site YoungspiritClub.</p>
      <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.key} className="glass rounded-2xl p-6" data-testid={`stat-${c.key}`}>
              <div className="flex items-center justify-between mb-4">
                <Icon className="text-amber-300" size={22} />
                {c.key === "reservations" && stats.reservations_new > 0 && (
                  <span className="flex items-center gap-1 text-xs text-emerald-300"><Bell size={12} /> {stats.reservations_new}</span>
                )}
              </div>
              <div className="font-mono-accent text-4xl text-amber-100">{stats[c.key]}</div>
              <div className="text-slate-400 text-sm mt-1">{c.label}</div>
              <div className="text-amber-400/60 text-xs mt-2 font-mono-accent">{c.sub(stats)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
